import React, { useState, useCallback, useEffect } from "react";
import {
  BiCheckCircle,
  BiRightArrowAlt,
  BiSolidArrowToRight,
  BiSolidXCircle,
  BiXCircle,
} from "react-icons/bi";
import {
  BsArrow90DegRight,
  BsArrowRight,
  BsFillCheckCircleFill,
  BsFillXCircleFill,
} from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { applyCustomFontStyles, THEME_SETTING } from "../data";
import debounce from "lodash.debounce";
import parse from "html-react-parser";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { baseUrl } from "../../../utils/constants";
import moment from "moment";
import { GiOpenTreasureChest } from "react-icons/gi";
import ShareEntity from "../../../components/ShareEntity/ShareEntity";
import StarRatings from "react-star-ratings";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import { setCurrentQuiz } from "../../../modules/actions";
import { getTextFromLanguageCodeAndKey } from "../languages";

export default function TriviaRatingBlock({
  view,
  themeSettings,

  isMobileView,

  quizResultObjectId,
  previewOnly,
  quizData,
  setCurrentQuiz,

  demoPreview,
  source,
  leaveRatingPage,
  setTrivvyRatingSubmitted,
  ratingSubmitted,
  trivvyLanguage,
  ...props
}) {
  const isMobile = isMobileView;
  const [starRating, setStarRating] = useState(quizData.rating || 0);

  const [comment, setComment] = useState("");
  const [customTextModal, setCustomTextModal] = useState(false);
  const [submitRatingLoading, setSubmitRatingLoading] = useState(false);

  const changeRating = (value) => {
    setStarRating(value);
    setCurrentQuiz({ ...quizData, rating: value });
  };

  const submitRating = () => {
    if (quizResultObjectId && !previewOnly) {
      setSubmitRatingLoading(true);
      axios
        .post(url.addStarRatingForTrivvy, {
          resultId: quizResultObjectId,
          rating: starRating,
          comment: comment,
        })
        .then((data) => {
          setSubmitRatingLoading(false);
          console.log(data.data);
          setTrivvyRatingSubmitted(true);
          leaveRatingPage();
        })
        .catch((err) => {
          setSubmitRatingLoading(false);
          leaveRatingPage();
          toastContainer("Error while adding rating", "error");
        });
    } else {
      leaveRatingPage();
    }
  };

  return (
    <div style={{ flex: 1, height: "100%" ,...applyCustomFontStyles(themeSettings)}}>
      <div
        style={{
          backgroundColor: themeSettings.quizBackgroundColor,
          color: themeSettings.quizTextColor,
          height: "100%",
        }}
      >
        <div
          className="trivia-survey-edit-questions-ui_question_title"
          style={{ paddingTop: isMobile ? "20%" : "2%" }}
        >
          <span
            className={
              isMobile
                ? "edit_survey_question_wrapper_noborder_mobile text-center"
                : "edit_survey_question_wrapper_noborder text-center"
            }
            style={{
              width: "100%",
              fontSize: "47px",
            }}
          >
            {parse(
              (quizData.ratingPage && quizData.ratingPage.heading) ||
                "<p>Please rate the Trivvy</p>"
            )}

            {quizData &&
            quizData.ratingPage &&
            quizData.ratingPage.isRequired ? (
              <span
                className="text-white font-13px"
                style={{ position: "absolute" }}
              >
                *Required
              </span>
            ) : (
              ""
            )}
          </span>
        </div>

        <div>
          <div className="my-5 text-center">
            <StarRatings
              rating={starRating}
              starRatedColor={quizData.ratingPage.starColor||"#F8D748"}
              changeRating={changeRating}
              numberOfStars={5}
              name="rating"
              starHoverColor={quizData.ratingPage.starColor||"#F8D748"}
            />

            <div className="my-3">
              <textarea
                rows={3}
                style={{ width: isMobile ? "250px" : "400px" }}
                placeholder={getTextFromLanguageCodeAndKey(
                  trivvyLanguage,
                  "ratingInputPlaceHolder"
                )}
                onChange={(e) => setComment(e.target.value)}
                value={comment}
              />
            </div>

            {submitRatingLoading ? (
              <div className="text-center">
                {getTextFromLanguageCodeAndKey(trivvyLanguage,"submitRatingLoading")} ...{" "}
              </div>
            ) : (
              <Button
                className="trivia-action-button-main"
                onClick={() => submitRating()}
                style={{ width: isMobile ? "250px" : "400px" }}
                disabled={!starRating}
              >
                {getTextFromLanguageCodeAndKey(trivvyLanguage,"submit")}
              </Button>
            )}

            <br />

            {!submitRatingLoading &&
            quizData &&
            quizData.ratingPage &&
            !quizData.ratingPage.isRequired ? (
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  leaveRatingPage();
                }}
                style={{
                  width: "100px",
                  marginTop: '40px',
                  // position: "fixed",
                  // bottom: "100px",
                  // right: isMobile ? "20px" : "60px",
                }}
              >
                 {getTextFromLanguageCodeAndKey(trivvyLanguage,"skip")}
              </Button>
            ) : (
              ""
            )}

            {quizData &&
            quizData.ratingPage &&
            quizData.ratingPage.isRequired ? (
              <p className="mt-3"> {getTextFromLanguageCodeAndKey(trivvyLanguage,"submitRatingRequiredMessage")}</p>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
